import { Routes } from '@angular/router';
import { LoginComponent } from './modules/login/pages/login/login.component';
import { authGuard } from './shared/guard/auth/auth.guard';
import { AuthorizationsRoutes, MainRoutes } from './shared/models/core/routes.models';
import { HomeComponent } from './modules/home/pages/home/home.component';

export const routes: Routes = [
  { path: '', redirectTo: MainRoutes.LOGIN, pathMatch: 'full' },
  { path: MainRoutes.LOGIN, component: LoginComponent },
  { path: MainRoutes.HOME, component: HomeComponent, canActivate: [authGuard] },
  {
    path: AuthorizationsRoutes.AUTHORIZATIONS,
    loadChildren: () => import('./modules/authorizations/authorizations.routes').then((m) => m.AUTHORIZATIONS_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: '**',
    redirectTo: MainRoutes.HOME
  }
];
